<template>

  <div>

    <tickets-table
      :status="status"
      :priority="priority"

      title-heading="h2"
      :owner-id="ownerId"

      :bottom-comp="bComp"
      :bottom-comp-props="bCompProps"

      />

  </div>

</template>



<script>

import TicketStats from '@/components/maintenance/TicketStats'
import TicketsTable from '@/components/tables/TicketsTable'

export default {

  components: {
    TicketsTable
  },

  watch: {

    '$route.params': {
      handler: function (p) {
        // A drawer segment (d.<name>…) lands in whichever positional slot
        // follows the active filters: /tickets/d.ticket.5 → status,
        // /tickets/open/d.ticket.5 → priority,
        // /tickets/null/urgent/d.ticket.5 → ownerId. Treat any d.-prefixed
        // value as absent so the open drawer never pollutes the filter.
        var notDrawer = function (v) {
          return (v && v.indexOf('d.') === 0) ? null : (v || null)
        }

        this.status = notDrawer(p.status)
        this.priority = notDrawer(p.priority)

        var ownerId = notDrawer(p.ownerId)
        if (ownerId) {
          this.ownerId = (!this.isTowerCo() ? this.org().id : Number(ownerId))
        }

        this.stats = this.getStats()
      },
      deep: true,
      immediate: true
    },

    stats: function (s) {
      this.stats = s
    }

  },

  data () {

    return {
      bComp: TicketStats,
      bCompProps: { stats: null },
      status: null,
      priority: null,
      ownerId: (this.isTelco() ? this.org().id : null),
      stats: null
    }

  },

  created () {
    this.stats = this.getStats(this.org().id, true)
  }

}
</script>
